// extracted by mini-css-extract-plugin
export default {"header":"Login_header__qXXuQ","link":"Login_link__dqraY","textPrimaryDark":"Login_textPrimaryDark__Vh+fN"};